import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-0a77a976")

_pushScopeId("data-v-0a77a976")
const _hoisted_1 = { class: "circular-border" }
const _hoisted_2 = { class: "content" }
const _hoisted_3 = { key: 1 }
const _hoisted_4 = { class: "order-status" }
const _hoisted_5 = { class: "header" }
const _hoisted_6 = /*#__PURE__*/_createVNode("h4", null, "Status do Pedido", -1)
const _hoisted_7 = { class: "order-id" }
const _hoisted_8 = /*#__PURE__*/_createVNode("h4", null, "Recusado", -1)
const _hoisted_9 = {
  key: 0,
  class: "pix"
}
const _hoisted_10 = /*#__PURE__*/_createVNode("h2", null, "Agora, é só pagar!", -1)
const _hoisted_11 = /*#__PURE__*/_createVNode("p", null, " Você pode pagar escaneando o QR Code acima ou pelo método Copia e Cola, apertando no botão abaixo. ", -1)
const _hoisted_12 = /*#__PURE__*/_createTextVNode(" Pix Copia e Cola ")
const _hoisted_13 = /*#__PURE__*/_createVNode("p", null, "O nome que aparecerá é Zoop Tecnologia.", -1)
const _hoisted_14 = /*#__PURE__*/_createVNode("span", null, " O pagamento deve ser feito em até 10 minutos. Depois desse tempo, o pedido será automaticamente recusado. ", -1)
const _hoisted_15 = {
  key: 1,
  class: "delivery-forecast"
}
const _hoisted_16 = { class: "item-header" }
const _hoisted_17 = { class: "quantity" }
const _hoisted_18 = { class: "name" }
const _hoisted_19 = { class: "value" }
const _hoisted_20 = { class: "suboption-name" }
const _hoisted_21 = {
  key: 0,
  class: "options"
}
const _hoisted_22 = /*#__PURE__*/_createVNode("p", null, "Observação", -1)
const _hoisted_23 = { class: "suboption-name" }
const _hoisted_24 = { class: "note" }
const _hoisted_25 = { class: "value-subinfo" }
const _hoisted_26 = /*#__PURE__*/_createVNode("p", null, "Subtotal", -1)
const _hoisted_27 = {
  key: 0,
  class: "value-subinfo"
}
const _hoisted_28 = /*#__PURE__*/_createVNode("p", null, "Desconto", -1)
const _hoisted_29 = {
  key: 1,
  class: "value-subinfo"
}
const _hoisted_30 = /*#__PURE__*/_createVNode("p", null, "Uso do saldo da carteira", -1)
const _hoisted_31 = { class: "value-subinfo" }
const _hoisted_32 = /*#__PURE__*/_createVNode("p", null, "Taxa de entrega", -1)
const _hoisted_33 = { class: "value-total" }
const _hoisted_34 = /*#__PURE__*/_createVNode("p", null, "Total", -1)
const _hoisted_35 = { key: 0 }
const _hoisted_36 = /*#__PURE__*/_createTextVNode(" Pago na entrega ")
const _hoisted_37 = { class: "payment-type" }
const _hoisted_38 = { class: "payment-value" }
const _hoisted_39 = { key: 1 }
const _hoisted_40 = /*#__PURE__*/_createVNode("p", null, "Pago Online", -1)
const _hoisted_41 = /*#__PURE__*/_createVNode("p", null, [
  /*#__PURE__*/_createTextVNode("Cashback "),
  /*#__PURE__*/_createVNode("span", null, "Dinheiro de volta")
], -1)
const _hoisted_42 = { class: "cashback-value" }
const _hoisted_43 = { key: 0 }
const _hoisted_44 = /*#__PURE__*/_createVNode("h4", null, "Endereço para retirada", -1)
const _hoisted_45 = { key: 1 }
const _hoisted_46 = /*#__PURE__*/_createVNode("h4", null, "Endereço para entrega", -1)
const _hoisted_47 = { class: "establishment-contact-info" }
const _hoisted_48 = /*#__PURE__*/_createVNode("div", null, [
  /*#__PURE__*/_createVNode("h4", null, "Falar com o TheLivery")
], -1)
const _hoisted_49 = /*#__PURE__*/_createVNode("p", null, "Deseja repetir este pedido?", -1)
const _hoisted_50 = /*#__PURE__*/_createVNode("span", null, "Toque aqui para repetir", -1)
const _hoisted_51 = /*#__PURE__*/_createVNode("h4", null, "Avaliação", -1)
const _hoisted_52 = /*#__PURE__*/_createVNode("span", null, "Comentário: ", -1)
const _hoisted_53 = /*#__PURE__*/_createVNode("span", null, "Resposta do estabelecimento: ", -1)
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_header_with_balance = _resolveComponent("header-with-balance")
  const _component_ion_refresher_content = _resolveComponent("ion-refresher-content")
  const _component_ion_refresher = _resolveComponent("ion-refresher")
  const _component_order_detail_skeleton = _resolveComponent("order-detail-skeleton")
  const _component_ion_card = _resolveComponent("ion-card")
  const _component_status_history = _resolveComponent("status-history")
  const _component_ion_icon = _resolveComponent("ion-icon")
  const _component_ion_button = _resolveComponent("ion-button")
  const _component_ion_card_content = _resolveComponent("ion-card-content")
  const _component_ion_label = _resolveComponent("ion-label")
  const _component_ion_item = _resolveComponent("ion-item")
  const _component_ion_content = _resolveComponent("ion-content")
  const _component_ion_toolbar = _resolveComponent("ion-toolbar")
  const _component_ion_footer = _resolveComponent("ion-footer")
  const _component_ion_page = _resolveComponent("ion-page")

  return (_openBlock(), _createBlock(_component_ion_page, null, {
    default: _withId(() => [
      _createVNode(_component_ion_content, null, {
        default: _withId(() => [
          _createVNode(_component_header_with_balance, {
            class: "balance-header",
            title: "Detalhes do Pedido",
            "has-go-back": true
          }),
          _createVNode("div", _hoisted_1, [
            _createVNode(_component_ion_refresher, {
              slot: "fixed",
              onIonRefresh: _cache[1] || (_cache[1] = ($event: any) => ($setup.doRefresh($event)))
            }, {
              default: _withId(() => [
                _createVNode(_component_ion_refresher_content)
              ]),
              _: 1
            }),
            _createVNode("div", _hoisted_2, [
              ($setup.loadingRef)
                ? (_openBlock(), _createBlock(_component_order_detail_skeleton, { key: 0 }))
                : (_openBlock(), _createBlock("div", _hoisted_3, [
                    _createVNode("div", _hoisted_4, [
                      _createVNode("div", _hoisted_5, [
                        _hoisted_6,
                        _createVNode("span", _hoisted_7, "#" + _toDisplayString($setup.orderInfoRef.id), 1)
                      ]),
                      ($setup.orderInfoRef.status.id == 6)
                        ? (_openBlock(), _createBlock(_component_ion_card, {
                            key: 0,
                            class: "card-refused"
                          }, {
                            default: _withId(() => [
                              _hoisted_8,
                              _createVNode("p", null, "Motivo: " + _toDisplayString($setup.orderInfoRef.justification), 1)
                            ]),
                            _: 1
                          }))
                        : (_openBlock(), _createBlock(_component_status_history, {
                            key: 1,
                            steps: $setup.orderInfoRef.possibleStatus,
                            status: $setup.orderInfoRef.status
                          }, null, 8, ["steps", "status"]))
                    ]),
                    ($setup.orderInfoRef.status.id == 0)
                      ? (_openBlock(), _createBlock("div", _hoisted_9, [
                          _hoisted_10,
                          _createVNode("img", { src: $options.qrcode }, null, 8, ["src"]),
                          _hoisted_11,
                          _createVNode(_component_ion_button, {
                            shape: "round",
                            fill: "outline",
                            onClick: $options.clipboardPix
                          }, {
                            default: _withId(() => [
                              _createVNode(_component_ion_icon, { icon: $setup.copySharp }, null, 8, ["icon"]),
                              _hoisted_12
                            ]),
                            _: 1
                          }, 8, ["onClick"]),
                          _hoisted_13,
                          _hoisted_14
                        ]))
                      : _createCommentVNode("", true),
                    ($setup.orderInfoRef.status.id != 6 && $setup.orderInfoRef.status.id != 5)
                      ? (_openBlock(), _createBlock("div", _hoisted_15, [
                          _createVNode(_component_ion_icon, { icon: $setup.time }, null, 8, ["icon"]),
                          _createVNode("span", null, "Previsão de entrega entre " + _toDisplayString($setup.formatTime1Ref) + " e " + _toDisplayString($setup.formatTime2Ref), 1)
                        ]))
                      : _createCommentVNode("", true),
                    _createVNode(_component_ion_card, { class: "products" }, {
                      default: _withId(() => [
                        _createVNode(_component_ion_card_content, null, {
                          default: _withId(() => [
                            (_openBlock(true), _createBlock(_Fragment, null, _renderList($setup.orderInfoRef.items, (item) => {
                              return (_openBlock(), _createBlock("div", {
                                key: item.id,
                                class: "item"
                              }, [
                                _createVNode("div", _hoisted_16, [
                                  _createVNode("p", _hoisted_17, _toDisplayString(item.quantity) + "x", 1),
                                  _createVNode("p", _hoisted_18, _toDisplayString(item.product.name), 1),
                                  _createVNode("p", _hoisted_19, _toDisplayString($options.moneyMask(item.liquid_value)), 1)
                                ]),
                                (_openBlock(true), _createBlock(_Fragment, null, _renderList(item.options, (option) => {
                                  return (_openBlock(), _createBlock("div", {
                                    key: option.id,
                                    class: "options"
                                  }, [
                                    _createVNode("p", null, _toDisplayString(option.option.name), 1),
                                    _createVNode("div", _hoisted_20, [
                                      _createVNode("p", null, _toDisplayString(option.quantity) + "x", 1),
                                      _createVNode("p", null, _toDisplayString(option.suboption.name), 1)
                                    ])
                                  ]))
                                }), 128)),
                                (item.note)
                                  ? (_openBlock(), _createBlock("div", _hoisted_21, [
                                      _hoisted_22,
                                      _createVNode("div", _hoisted_23, [
                                        _createVNode("p", _hoisted_24, "\"" + _toDisplayString(item.note) + "\"", 1)
                                      ])
                                    ]))
                                  : _createCommentVNode("", true)
                              ]))
                            }), 128))
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_ion_card, { class: "value-totals" }, {
                      default: _withId(() => [
                        _createVNode(_component_ion_card_content, null, {
                          default: _withId(() => [
                            _createVNode("div", _hoisted_25, [
                              _hoisted_26,
                              _createVNode("p", null, _toDisplayString($options.moneyMask($setup.orderInfoRef.products_value)), 1)
                            ]),
                            ($setup.orderInfoRef.discount_value)
                              ? (_openBlock(), _createBlock("div", _hoisted_27, [
                                  _hoisted_28,
                                  _createVNode("p", null, "- " + _toDisplayString($options.moneyMask($setup.orderInfoRef.discount_value)), 1)
                                ]))
                              : _createCommentVNode("", true),
                            ($setup.orderInfoRef.amount_of_balance_used)
                              ? (_openBlock(), _createBlock("div", _hoisted_29, [
                                  _hoisted_30,
                                  _createVNode("p", null, " - " + _toDisplayString($options.moneyMask($setup.orderInfoRef.amount_of_balance_used)), 1)
                                ]))
                              : _createCommentVNode("", true),
                            _createVNode("div", _hoisted_31, [
                              _hoisted_32,
                              _createVNode("p", null, _toDisplayString($setup.orderInfoRef.delivery_fee == 0
                        ? "Grátis"
                        : $options.moneyMask($setup.orderInfoRef.delivery_fee)), 1)
                            ]),
                            _createVNode("div", _hoisted_33, [
                              _hoisted_34,
                              _createVNode("p", null, _toDisplayString($options.moneyMask($setup.orderInfoRef.total_value)), 1)
                            ])
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_ion_card, { class: "payment" }, {
                      default: _withId(() => [
                        _createVNode(_component_ion_card_content, null, {
                          default: _withId(() => [
                            (!$setup.orderInfoRef.is_online_payment)
                              ? (_openBlock(), _createBlock("div", _hoisted_35, [
                                  _createVNode("div", null, [
                                    _createVNode("p", null, [
                                      _hoisted_36,
                                      _createVNode("span", _hoisted_37, _toDisplayString($setup.orderInfoRef.payment.paymentMethod.name), 1)
                                    ])
                                  ]),
                                  _createVNode("p", _hoisted_38, _toDisplayString($options.moneyMask($setup.orderInfoRef.total_value)), 1)
                                ]))
                              : (_openBlock(), _createBlock("div", _hoisted_39, [
                                  _hoisted_40,
                                  _createVNode("p", null, _toDisplayString($options.moneyMask($setup.orderInfoRef.total_value)), 1)
                                ]))
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }),
                    ($setup.orderInfoRef.cashback_given)
                      ? (_openBlock(), _createBlock(_component_ion_card, {
                          key: 2,
                          class: "cashback"
                        }, {
                          default: _withId(() => [
                            _createVNode(_component_ion_card_content, null, {
                              default: _withId(() => [
                                _hoisted_41,
                                _createVNode("p", _hoisted_42, " + " + _toDisplayString($options.moneyMask($setup.orderInfoRef.cashback_given)), 1)
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        }))
                      : _createCommentVNode("", true),
                    _createVNode(_component_ion_card, { class: "delivery" }, {
                      default: _withId(() => [
                        _createVNode(_component_ion_card_content, null, {
                          default: _withId(() => [
                            ($setup.orderInfoRef.withdrawn === 'S')
                              ? (_openBlock(), _createBlock("div", _hoisted_43, [
                                  _hoisted_44,
                                  _createVNode("p", null, _toDisplayString($setup.orderInfoRef.establishment?.address) + ", " + _toDisplayString($setup.orderInfoRef.establishment?.address_number) + ", " + _toDisplayString($setup.orderInfoRef.establishment?.neighborhood?.name), 1),
                                  _createVNode("p", null, _toDisplayString($setup.orderInfoRef.establishment?.address_complement), 1),
                                  _createVNode("p", null, _toDisplayString($setup.orderInfoRef.establishment?.address_reference), 1)
                                ]))
                              : (_openBlock(), _createBlock("div", _hoisted_45, [
                                  _hoisted_46,
                                  _createVNode("p", null, _toDisplayString($setup.orderInfoRef.address?.street_name) + ", " + _toDisplayString($setup.orderInfoRef.address?.address_number), 1),
                                  _createVNode("p", null, _toDisplayString($setup.orderInfoRef.address?.complement), 1),
                                  _createVNode("p", null, _toDisplayString($setup.orderInfoRef.address?.reference), 1)
                                ]))
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_ion_card, { class: "establishment-info" }, {
                      default: _withId(() => [
                        _createVNode(_component_ion_card_content, null, {
                          default: _withId(() => [
                            _createVNode("div", null, [
                              _createVNode("h4", null, _toDisplayString($setup.orderInfoRef.establishment?.name), 1),
                              _createVNode("p", null, "Telefone: " + _toDisplayString($setup.orderInfoRef.establishment?.phone), 1)
                            ]),
                            _createVNode("div", _hoisted_47, [
                              ($setup.orderInfoRef.canChat)
                                ? (_openBlock(), _createBlock(_component_ion_button, {
                                    key: 0,
                                    fill: "clear",
                                    onClick: $options.openRestaurantChat
                                  }, {
                                    default: _withId(() => [
                                      ($data.hasUnreadMessages)
                                        ? (_openBlock(), _createBlock(_component_ion_icon, {
                                            key: 0,
                                            color: "primary",
                                            icon: $setup.chatbubbleEllipses
                                          }, null, 8, ["icon"]))
                                        : (_openBlock(), _createBlock(_component_ion_icon, {
                                            key: 1,
                                            color: "primary",
                                            icon: $setup.chatbubbleOutline
                                          }, null, 8, ["icon"]))
                                    ]),
                                    _: 1
                                  }, 8, ["onClick"]))
                                : _createCommentVNode("", true),
                              _createVNode("a", {
                                href: `tel:${$setup.orderInfoRef.establishment?.phone}`
                              }, [
                                _createVNode(_component_ion_icon, {
                                  color: "primary",
                                  icon: $setup.callOutline
                                }, null, 8, ["icon"])
                              ], 8, ["href"])
                            ])
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_ion_card, { class: "chat-thelivery" }, {
                      default: _withId(() => [
                        _createVNode(_component_ion_card_content, { onClick: $setup.toggleChat }, {
                          default: _withId(() => [
                            _hoisted_48,
                            _createVNode(_component_ion_icon, {
                              color: "primary",
                              icon: $setup.chatbubblesOutline
                            }, null, 8, ["icon"])
                          ]),
                          _: 1
                        }, 8, ["onClick"])
                      ]),
                      _: 1
                    }),
                    ($setup.orderInfoRef.canRepeat)
                      ? (_openBlock(), _createBlock(_component_ion_card, {
                          key: 3,
                          class: "can-repeat",
                          onClick: $options.remakeOrder
                        }, {
                          default: _withId(() => [
                            _createVNode(_component_ion_card_content, null, {
                              default: _withId(() => [
                                _hoisted_49,
                                _hoisted_50
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        }, 8, ["onClick"]))
                      : _createCommentVNode("", true),
                    ($setup.orderInfoRef.rating)
                      ? (_openBlock(), _createBlock(_component_ion_card, {
                          key: 4,
                          class: "rating-view"
                        }, {
                          default: _withId(() => [
                            _createVNode(_component_ion_card_content, null, {
                              default: _withId(() => [
                                _createVNode(_component_ion_item, {
                                  lines: "none",
                                  class: "no-padding"
                                }, {
                                  default: _withId(() => [
                                    _hoisted_51,
                                    _createVNode(_component_ion_label, null, {
                                      default: _withId(() => [
                                        _createTextVNode(_toDisplayString($options.formatRating($setup.orderInfoRef.rating)) + " ", 1),
                                        _createVNode(_component_ion_icon, { icon: $setup.star }, null, 8, ["icon"])
                                      ]),
                                      _: 1
                                    })
                                  ]),
                                  _: 1
                                }),
                                ($setup.orderInfoRef.comment)
                                  ? (_openBlock(), _createBlock(_component_ion_item, {
                                      key: 0,
                                      lines: "none",
                                      class: "no-padding comment"
                                    }, {
                                      default: _withId(() => [
                                        _createVNode(_component_ion_label, null, {
                                          default: _withId(() => [
                                            _hoisted_52,
                                            _createTextVNode(_toDisplayString($setup.orderInfoRef.comment), 1)
                                          ]),
                                          _: 1
                                        })
                                      ]),
                                      _: 1
                                    }))
                                  : _createCommentVNode("", true),
                                ($setup.orderInfoRef.reply)
                                  ? (_openBlock(), _createBlock(_component_ion_item, {
                                      key: 1,
                                      lines: "none",
                                      class: "no-padding reply"
                                    }, {
                                      default: _withId(() => [
                                        _createVNode(_component_ion_label, null, {
                                          default: _withId(() => [
                                            _hoisted_53,
                                            _createTextVNode(_toDisplayString($setup.orderInfoRef.reply), 1)
                                          ]),
                                          _: 1
                                        })
                                      ]),
                                      _: 1
                                    }))
                                  : _createCommentVNode("", true)
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        }))
                      : _createCommentVNode("", true)
                  ]))
            ])
          ])
        ]),
        _: 1
      }),
      (!$setup.loadingRef && $setup.orderInfoRef.canRate)
        ? (_openBlock(), _createBlock(_component_ion_footer, { key: 0 }, {
            default: _withId(() => [
              _createVNode(_component_ion_toolbar, { class: "rating" }, {
                default: _withId(() => [
                  _createVNode(_component_ion_button, {
                    class: "rating-button",
                    expand: "full",
                    shape: "round",
                    onClick: $options.orderRating
                  }, {
                    default: _withId(() => [
                      _createTextVNode(_toDisplayString($setup.orderInfoRef.rating ? `Editar Avaliação` : `Avaliar Pedido`), 1)
                    ]),
                    _: 1
                  }, 8, ["onClick"])
                ]),
                _: 1
              })
            ]),
            _: 1
          }))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }))
})